import { NAV_HREFS } from '../../content/landing'
import { sectionGap, wrap } from '../layout.js'

/**
 * Footer: the wordmark and what the site is, then the page's own links and
 * the legal ones. `lang` is needed because the privacy policy lives under the
 * locale segment (`/uz/privacy`), unlike the in-page anchors beside it.
 */
export function SiteFooter({ t, desktop, lang }) {
  return (
    <footer style={{ ...wrap(desktop), paddingBottom: sectionGap(desktop) }}>
      <div
        style={{
          marginTop: sectionGap(desktop),
          paddingTop: 40,
          borderTop: '1px solid var(--border-1)',
          display: 'grid',
          gridTemplateColumns: desktop ? '1.6fr 1fr 1fr' : '1fr',
          gap: desktop ? 32 : 28,
        }}
      >
        <div>
          <a href="#top" className="u-wordmark" style={{ fontSize: 20 }}>
            Uniap
          </a>
          <p
            style={{
              margin: '10px 0 0',
              fontSize: 14,
              color: 'var(--ink-3)',
              lineHeight: 1.55,
              maxWidth: 320,
            }}
          >
            {t.footerTagline}
          </p>
        </div>

        <nav aria-label={t.footerNavLabel}>
          <h2 className="u-footer-head">{t.footerProduct}</h2>
          <ul className="u-footer-col">
            {t.nav.map((n, i) => (
              <li key={n}>
                <a href={NAV_HREFS[i]} className="u-nav-link">
                  {n}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <div>
          <h2 className="u-footer-head">{t.footerLegal}</h2>
          <ul className="u-footer-col">
            <li>
              <a href={`/${lang}/privacy`} className="u-nav-link">
                {t.privacy}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <p
        style={{
          margin: '32px 0 0',
          paddingTop: 20,
          borderTop: '1px solid var(--border-1)',
          fontSize: 13,
          color: 'var(--ink-3)',
        }}
      >
        {t.copy}
      </p>
    </footer>
  )
}

export default SiteFooter
